// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import stars01Icon from "@/assets/icons/stars-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Stars01IconProps = Omit<IconProps, "name">;

export function Stars01Icon(props: Stars01IconProps): React.ReactNode {
  return <Icon name={stars01Icon} {...props} />;
}
